import { PageRef } from 'providers/page-ref';

export type ViewExercisePageParams = {
  id: string;
  /**
   * Share links built before this page existed carry `mode=view`, because the read-only
   * screen used to be a mode of the edit page. Those links are out in the world and cannot
   * be recalled, so the param is still accepted here and simply ignored — the page has one
   * behaviour and no modes.
   */
  mode?: string;
  returnCallback?: string;
  local?: {
    returnContext?: unknown;
  };
};

/** The exercise ID, so a parent's returnCallback learns which exercise was viewed. */
export type ViewExercisePageResult = string;

export const IViewExercisePage: PageRef<ViewExercisePageParams, ViewExercisePageResult> = {
  pageName: 'ViewExercisePage',
} as PageRef<ViewExercisePageParams, ViewExercisePageResult>;
